import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import * as CryptoJS from "crypto-js";

@Injectable()
export class DecryptInterceptor implements HttpInterceptor {
  private SECRET_KEY = CryptoJS.enc.Utf8.parse("0123456789ABCDEF0123456789ABCDEF"); // 32-byte key
  private IV = CryptoJS.enc.Utf8.parse("ABCDEF1234567890"); // 16-byte IV

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event) => {
        if (event instanceof HttpResponse) {
          // Check if encryption header exists
          const encryptHeader = event.headers.get("X-Response-Encrypted");
          if (encryptHeader === "true" && event.body) {
            try {
              const decryptedData = this.decryptData(event.body?.payload);
              return event.clone({ body: JSON.parse(decryptedData) });
            } catch (error) {
              console.error("Decryption error", error);
            }
          }
        }
        return event;
      })
    );
  }

  private decryptData(encryptedText: string): string {
    const bytes = CryptoJS.AES.decrypt(encryptedText, this.SECRET_KEY, { iv: this.IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return bytes.toString(CryptoJS.enc.Utf8);
  }
}
